import { createContext } from 'react'
import type { Recipient as MessageBoxRecipient } from '@app/components/blocks/messageBox/RecipientModel'

export type Recipient = MessageBoxRecipient
export type MessageContext = {
  recipients: Recipient[]
  selectedRecipientId?: number
  initiativeId: number
}

export type MessageBoxContextType = {
  showMessageBox: (
    allRecipientIds: Recipient[],
    initiativeId: number,
    recipientId?: number,
  ) => void
}

export const MessageBoxContext = createContext<MessageBoxContextType>({
  showMessageBox: () => {},
})
